import { Animation, Colors, Typography } from '@zapier/design-system';
import { isolateComponent, labelStyles } from '@zapier/style-encapsulation';
const Styles = labelStyles('UniversalSidebarError', {
    toggle: Object.assign(Object.assign({}, Typography.smallPrint1), { color: Colors.error, cursor: 'pointer', padding: '3px 0', borderBottom: `1px solid transparent`, transition: Animation.transitionValue, '&:hover, &:focus': {
            borderBottomColor: Colors.error,
        } }),
    message: {
        color: Colors.error,
        marginTop: 10,
        padding: 10,
        border: `1px solid ${Colors.gray20}`,
        borderRadius: 5,
        font: '14px/18px monospace',
    },
});
const UniversalSidebarError = (props) => {
    return (isolateComponent("details", null,
        isolateComponent("summary", { css: Styles.toggle }, "Oh no, something went wrong!"),
        isolateComponent("pre", { css: Styles.message }, props.children)));
};
export default UniversalSidebarError;
//# sourceMappingURL=UniversalSidebarError.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)
